import type {
  CoachingGoalMilestone,
  CoachingGoalReflection,
} from '@efdigital/ll-addon-data';

function relationshipId(relationship: unknown): string | null {
  if (!relationship || typeof relationship !== 'object') {
    return null;
  }

  const id = (relationship as { id?: unknown }).id;

  if (typeof id === 'string' || id === null) {
    return id;
  }

  if (typeof id === 'function') {
    const legacyId = id.call(relationship) as unknown;

    return typeof legacyId === 'string' || legacyId === null ? legacyId : null;
  }

  return null;
}

export function milestonesForGoal(
  milestones: readonly CoachingGoalMilestone[],
  goalId: string
): CoachingGoalMilestone[] {
  return milestones
    .filter(
      (milestone) =>
        String(relationshipId(milestone.coachingGoal)) === String(goalId)
    )
    .sort((left, right) => left.position - right.position);
}

export function reflectionsForGoal(
  reflections: readonly CoachingGoalReflection[],
  goalId: string
): CoachingGoalReflection[] {
  return reflections
    .filter(
      (reflection) =>
        String(relationshipId(reflection.coachingGoal)) === String(goalId)
    )
    .sort(
      (left, right) =>
        new Date(right.createdAt).getTime() - new Date(left.createdAt).getTime()
    );
}
